module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity16.a891e10b.jpg";